import { map } from 'lodash';

import Table, {
  THead, TBody, Tr, Th, Td,
} from 'components/UIKit/Table';
import Column from 'components/UIKit/Flex/Column';
import Row from 'components/UIKit/Flex/Row';
import { SUBMITTABLE_EXPERIMENTAL_STRATEGIES } from 'constants/constants';
import { SpinnerOverlay } from 'components/UIKit/Spinner';

const styles = {
  title: {
    fontSize: '1.3rem',
    alignItems: 'center',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    margin: 0,
  },
  subtitle: {
    fontSize: '0.9rem',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
  },
  numCell: {
    textAlign: 'right',
  },
  table: {
    padding: '0.5rem',
    border: '1px solid rgb(236, 236, 236)',
    margin: '10px',
    width: 'auto',
  },
};

const QCMetadataTable = ({
  metadata,
}) => {
  const { caseCount, aliquotCount, readGroupCount } = metadata.data;

  const dataByStrategy = map(SUBMITTABLE_EXPERIMENTAL_STRATEGIES, (value, key) => ({
    strategy: value,
    aligned: metadata.data[`SAR_${key}Count`] || 0,
    unaligned: metadata.data[`SUR_${key}Count`] || 0
  }));

  return (
    <Column data-testid="table-metadata-summary" className="qc-summary pdf-only">
      <Column style={{ margin: 0, padding: '0px 0px 0px 0.5rem' }}>
        <h3 className="qc-summary-toolbar pdf-only" style={styles.title}>Metadata Summary</h3>
        <span style={styles.subtitle}>Total counts of unsubmitted entities.</span>
      </Column>
      <Column>
        <SpinnerOverlay isLoading={metadata.isFetching}>
        <Column>
          {!metadata.isFetching && (
            <Row style={{ padding: '1rem 0' }} className="pdf-display-block">
              <Table customDataTestID="table-metadata-cases" className="metadata-summary" style={styles.table}>
                <THead>
                  <Tr >
                    <Th style={styles.numCell}>Cases</Th>
                    <Th style={styles.numCell}>Aliquots</Th>
                    <Th style={styles.numCell}>Read Groups</Th>
                  </Tr>
                </THead>
                <TBody>
                  <Tr>
                    <Td style={styles.numCell}>{caseCount || 0}</Td>
                    <Td style={styles.numCell}>{aliquotCount || 0}</Td>
                    <Td style={styles.numCell}>{readGroupCount || 0}</Td>
                  </Tr>
                </TBody>
              </Table>

              <Table customDataTestID="table-metadata-aligned-unaligned" className="metadata-summary" style={styles.table}>
                <THead>
                  <Tr>
                    <Td/>
                    { dataByStrategy.map(({ strategy }) => <Th key={strategy} style={styles.numCell}>{strategy}</Th>) }
                  </Tr>
                </THead>
                <TBody>
                  <Tr customDataTestID="row-aligned">
                    <Td>Aligned</Td>
                    {dataByStrategy.map(({ strategy, aligned }) => <Td key={strategy} style={styles.numCell}>{aligned}</Td>)}
                  </Tr>
                  <Tr customDataTestID="row-unaligned">
                    <Td>Unaligned</Td>
                    {dataByStrategy.map(({ strategy, unaligned }) => <Td key={strategy} style={styles.numCell}>{unaligned}</Td>)}
                  </Tr>
                </TBody>
              </Table>
            </Row>
          )}
        </Column>
        </SpinnerOverlay>
      </Column>
    </Column>
  );
};

export default QCMetadataTable;
